// src/routes/index.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import AdminLayout from '../layouts/admin/AdminLayout';
import ClientLayout from '../layouts/client/ClientLayout';

// Pages client
import HomePage from '../pages/client/HomePage';
import PackageDetailsPage from '../pages/client/PackageDetailsPage';
import SearchResultsPage from '../pages/client/SearchResultsPage';

// Pages admin
import LoginPage from '../pages/admin/LoginPage';
import DashboardPage from '../pages/admin/DashboardPage';
import CompanyManagementPage from '../pages/admin/CompanyManagementPage';
import PackageManagementPage from '../pages/admin/PackageManagementPage';
import CompanyProfilePage from '../pages/admin/CompanyProfilePage';
import SettingsPage from '../pages/admin/SettingsPage';

// Composant de route protégée
import ProtectedRoute from '../components/common/ProtectedRoute';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Routes Client */}
        <Route path="/" element={<ClientLayout />}>
          <Route index element={<HomePage />} />
          <Route path="forfaits/:id" element={<PackageDetailsPage />} />
          <Route path="recherche" element={<SearchResultsPage />} />
        </Route>
        
        {/* Routes Admin */}
        <Route path="/admin/login" element={<LoginPage />} />
        
        {/* Routes protégées pour tous les admins */}
        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="profile" element={<CompanyProfilePage />} />
            <Route path="forfaits" element={<PackageManagementPage />} />
          </Route>
        </Route>
        
        {/* Routes protégées pour le super admin uniquement */}
        <Route path="/admin" element={<ProtectedRoute requiredRole="SUPER_ADMIN" />}>
          <Route element={<AdminLayout />}>
            <Route path="compagnies" element={<CompanyManagementPage />} />
            <Route path="parametres" element={<SettingsPage />} />
          </Route>
        </Route>
        
        {/* Route par défaut */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;